// Components
import Validation from '@/js/components/forms/validation';

class Valuation {
  constructor() {
    this.dom = {
      formContact: document.getElementById('form-contact'),
      formValuation: document.getElementById('form-valuation'),
      alertScroll: document.querySelector('.js-alert-scroll:not(.d-none)'),
    };

    this.components = {
      contactFormValidation: null,
      valuationFormValidation: null,
    };

    this.mount();
  }

  mount() {
    if (this.dom.formContact) {
      this.components.contactFormValidation = new Validation(this.dom.formContact);
    }

    if (this.dom.formValuation) {
      this.components.valuationFormValidation = new Validation(this.dom.formValuation);
    }

    if (this.dom.alertScroll) {
      this.dom.alertScroll.scrollIntoView({ behavior: 'smooth' });
    }
  }
}

if (document.getElementById('page-valuation')) {
  // eslint-disable-next-line no-new
  new Valuation();
}
